import { Injectable } from '@angular/core';
import { CusHttp } from '../../core/services/CusHttp';

//岗位类型列表接口
const CITYLISTURL = "v1/region/post-city";
@Injectable()
export class AddrModalService {

  constructor(public _http: CusHttp, ) { }
  //岗位类型
  getCityList() {
    return this._http.get(CITYLISTURL);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/addr-modal/addr-modal.service.ts